<script>
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import MessageForm from '../Message/MessageForm.vue'
import DocumentDownloadButton from '../Document/DocumentDownloadButton.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import DocumentAction from '../Document/DocumentAction.vue'

export default {
  components: {
    DocumentAction,
    ButtonAll,
    DocumentDownloadButton,
    MessageForm,
    ModalConfirmation,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    purchaseorders: { type: Object, default: [], required: true },
    idModalPage: { type: String, default: '' },
    totalAmounts: { type: Object, default: [] },
  },

  data() {
    return {
      fields: [],
      validationIsLoading: false,
      cancelationIsLoading: false,
      currentPurchaseOrderId: null,
    }
  },

  methods: {
    validatePurchaseOrder(id) {
      this.validationIsLoading = true
      this.patchJSON('purchaseorder/' + id, {}).then(
        (purchaseOrder) => {
          const index = this.purchaseorders.findIndex((po) => po.id === purchaseOrder.id)
          if (index !== -1) {
            this.purchaseorders.splice(index, 1, purchaseOrder)
          }
          this.validationIsLoading = false

          this.$emit('purchase-sent')
        },
        () => {
          this.validationIsLoading = false
        },
      )
    },
    sendPurchaseOrder(id) {
      this.showMessageForm(id)
    },
    cancelPurchaseOrder(id) {
      this.currentPurchaseOrderId = id
      this.$refs.modalConfirmationCancel.showModal()
    },
    confirmCancel() {
      let id = this.currentPurchaseOrderId
      this.$refs.modalConfirmationCancel.closeModal()
      this.cancelationIsLoading = true
      this.patchJSON('purchaseorder/' + id + '/cancel', {}).then(
        (purchaseOrder) => {
          const index = this.purchaseorders.findIndex((po) => po.id === purchaseOrder.id)
          if (index !== -1) {
            this.purchaseorders.splice(index, 1, purchaseOrder)
          }
          this.cancelationIsLoading = false

          this.$emit('purchase-canceled')
        },
        () => {
          this.cancelationIsLoading = false
        },
      )
    },
    showMessageForm(id) {
      this.$nextTick((e) => {
        if (this.$refs['messageForm' + id][0]) {
          this.$refs['messageForm' + id][0].showForm()
        } else {
          $('#modal-message' + contextId).modal('toggle')
        }
      })
    },
    messageSent() {
      this.$emit('message-sent')
    },
  },
}
</script>
<template>
  <div>
    <ModalConfirmation
      ref="modalConfirmationCancel"
      id="cancel"
      @confirm="confirmCancel"
      title="contract.information.actionConfirmed.cancelPurchaseOrder"
      button-cancel-title="main.close"
    ></ModalConfirmation>
    <div class="purchaseorders-list">
      <div class="table-responsive-sm">
        <table v-if="purchaseorders.length > 0" class="table table-striped table-hover fs-16">
          <thead>
            <tr>
              <th>{{ $t('purchaseOrder.list.entity') }}</th>
              <th>{{ $t('purchaseOrder.list.number') }}</th>
              <th>{{ $t('purchaseOrder.list.status') }}</th>
              <th>{{ $t('purchaseOrder.list.sendingStatus') }}</th>
              <th class="text-right">{{ $t('purchaseOrder.list.amount') }}</th>
              <th class="text-right">{{ $t('purchaseOrder.table.totalAmountOrderedSupplier') }}</th>
              <th class="text-right">{{ $t('purchaseOrder.table.totalAmountDeliveredSupplier') }}</th>
              <th>{{ $t('purchaseOrder.list.action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="purchaseorder in purchaseorders" :e2e-row="'purchaseOrder-' + purchaseorder.id">
              <td e2e-data="purchaseOrderEntityName">{{ purchaseorder.entityName }}</td>
              <td e2e-data="purchaseOrderNumber">{{ purchaseorder.number }}</td>
              <td e2e-data="purchaseOrderStatus">{{ $t('purchaseOrder.status.' + purchaseorder.status) }}</td>
              <td e2e-data="purchaseOrderSendingStatus">
                {{ $t('purchaseOrder.status.' + purchaseorder.sendingStatus) }}
              </td>
              <td class="text-right" e2e-data="purchaseOrderAmount">
                {{ $n(Number(purchaseorder.amount), 'currency') }}
              </td>
              <td class="text-right" e2e-data="purchaseOrderAmountOrdered">
                {{ $n(Number(purchaseorder.amountOrdered), 'currency') }}
              </td>
              <td class="text-right" e2e-data="purchaseOrderAmountDelivered">
                {{ $n(Number(purchaseorder.amountDelivered), 'currency') }}
              </td>
              <td class="d-flex align-items-center">
                <div v-if="purchaseorder.status !== 'CANCELED'">
                  <ButtonAll
                    v-if="purchaseorder.validatedAt === null"
                    type="validation"
                    margin="no"
                    :loading="validationIsLoading"
                    label="purchaseOrder.action.toValid"
                    @click="validatePurchaseOrder(purchaseorder.id)"
                    name="purchaseOrderValidate"
                  />
                  <ButtonAll
                    v-else
                    type="validation"
                    margin="no"
                    label="purchaseOrder.action.toSend"
                    @click="sendPurchaseOrder(purchaseorder.id)"
                    name="purchaseOrderSend"
                  />
                  <ButtonAll
                    v-if="purchaseorder.validatedAt !== null"
                    type="warning"
                    margin="ml"
                    :loading="cancelationIsLoading"
                    label="purchaseOrder.action.cancel"
                    @click="cancelPurchaseOrder(purchaseorder.id)"
                    name="purchaseOrderCancel"
                  />
                  <MessageForm
                    :ref="'messageForm' + purchaseorder.id"
                    :context-id="purchaseorder.id"
                    context="Igoon/EnterpriseBundle/Entity/PurchaseOrder"
                    hide
                    media="EMAIL"
                    @message-sent="messageSent"
                  />
                </div>
                <DocumentAction
                  v-if="purchaseorder.validatedAt !== null"
                  context="Igoon\EnterpriseBundle\Entity\PurchaseOrder"
                  :context-id="purchaseorder.id"
                  download-action
                />
                <DocumentDownloadButton
                  v-else-if="purchaseorder.validatedAt === null"
                  :document="purchaseorder"
                  context="purchaseorder"
                  have-btn
                />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="font-weight-bold text-right" e2e-data="purchaseOrderTotalAmountToOrderSupplier">
                {{ $n(Number(totalAmounts.totalAmountToOrderSupplier), 'currency') }}
              </td>
              <td class="font-weight-bold text-right" e2e-data="purchaseOrderTotalAmountOrderedSupplier">
                {{ $n(Number(totalAmounts.totalAmountOrderedSupplier), 'currency') }}
              </td>
              <td class="font-weight-bold text-right" e2e-data="purchaseOrderTotalAmountDeliveredSupplier">
                {{ $n(Number(totalAmounts.totalAmountDeliveredSupplier), 'currency') }}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
